import { render, staticRenderFns } from "./NewItemCard.vue?vue&type=template&id=3d9f92e3&scoped=true&"
import script from "./NewItemCard.vue?vue&type=script&lang=js&"
export * from "./NewItemCard.vue?vue&type=script&lang=js&"
import style0 from "./NewItemCard.vue?vue&type=style&index=0&id=3d9f92e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9f92e3",
  null
  
)

export default component.exports